var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from 'goober';
import { forwardRef } from 'react';
var itemHeight = 32;
export var ContextMenuContainer = styled('div')(function () { return ({
    position: 'fixed',
    width: '1px',
    height: '1px',
    zIndex: 602,
}); });
export var ContextMenuBox = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $direction = _a.$direction;
    return ({
        margin: '0px',
        padding: '8px',
        minWidth: $direction === 'horizontal' ? '8px' : '167px',
        position: 'fixed',
        width: 'fit-content',
        display: 'flex',
        flexDirection: $direction === 'vertical' ? 'column' : $direction === 'horizontal' ? 'row' : 'inherit',
        backgroundColor: 'white',
        border: '1px solid #e9eef5',
        borderRadius: '0px 5px 5px 5px',
        boxShadow: "0px 4px 16px ".concat(theme.boxShadow),
        zIndex: 500,
    });
});
export var ContextSubMenuBox = styled(ContextMenuBox, forwardRef)(function (_a) {
    var $menuDirection = _a.$menuDirection;
    return $menuDirection === 'vertical'
        ? {
            position: 'absolute',
            left: '99%',
            transform: 'translateY(calc(50% - #{$item-height} / 2))',
        }
        : {
            position: 'absolute',
            top: '99%',
            transform: 'translateX(calc(50% - #{$item-width} / 2))',
        };
});
export var ContextMenuBoxItem = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, _b = _a.$isComponent, $isComponent = _b === void 0 ? false : _b, _c = _a.$isDisabled, $isDisabled = _c === void 0 ? false : _c, _d = _a.$iconOnly, $iconOnly = _d === void 0 ? false : _d;
    var extraStyles = {};
    if (!$isComponent) {
        extraStyles = {
            '&:hover': {
                background: theme === null || theme === void 0 ? void 0 : theme.colors.neutral.w100,
            },
        };
    }
    return __assign({ display: 'flex', cursor: 'pointer', padding: $iconOnly ? '0px 8px' : '0px', alignItems: 'center', justifyContent: 'center', minHeight: "".concat(itemHeight, "px"), opacity: $isDisabled ? 0.5 : 1, pointerEvents: $isDisabled ? 'none' : 'all', borderRadius: '6px', '>svg': {
            flexShrink: 0,
            opacity: $isDisabled ? 0.5 : 1,
        }, input: {
            fontSize: '12px',
        } }, extraStyles);
});
export var ContextMenuComponent = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        margin: ' 5px 0px',
        width: '90px',
    });
});
export var ContextMenuLabel = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$destructive, $destructive = _b === void 0 ? false : _b, _c = _a.$creative, $creative = _c === void 0 ? false : _c, _d = _a.$disabled, $disabled = _d === void 0 ? false : _d, _e = _a.$fillIconSpace, $fillIconSpace = _e === void 0 ? false : _e;
    var color = theme === null || theme === void 0 ? void 0 : theme.colors.ui.dark;
    var weight = 'normal';
    var paddingLeft = '8px';
    if ($creative) {
        color = theme === null || theme === void 0 ? void 0 : theme.colors.primary.w500;
        weight = 'bold';
    }
    if ($destructive) {
        color = theme === null || theme === void 0 ? void 0 : theme.colors.error.w500;
        weight = 'bold';
    }
    if ($disabled) {
        color = theme === null || theme === void 0 ? void 0 : theme.colors.ui.dark;
    }
    if ($fillIconSpace) {
        paddingLeft = '16px';
    }
    return {
        width: '100%',
        fontSize: '12px',
        color: color,
        fontWeight: weight,
        paddingLeft: paddingLeft,
        paddingRight: '8px',
    };
});
export var ContextMenuVerticalHr = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        margin: '8px 0px',
        borderTop: "1px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.neutral.w300),
    });
});
export var ContextMenuHorizontalHr = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        margin: '0px 8px',
        borderLeft: "1px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.neutral.w300),
    });
});
